<template>
  <!-- 外层容器 -->
  <div class="w-full h-auto pt-[3.75vw] pb-[2vw]">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          发展历程
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          自主研发教材+教具+赛事实训一体化教学模式，累计服务学生50000+
        </div>
      </div>
    </div>

    <!-- 容器区域 -->
    <div class="relative w-[61.46vw] h-[32.19vw] left-1/2 -translate-x-1/2">
      <el-image
        class="w-full h-full object-cover"
        :src="require('@/assets/images/AboutUs/module6/sample1.png')"
        lazy
        alt="背景图"
      />
      <!-- 线条图 + 反光 -->
      <div
        class="absolute w-[61.46vw] h-[32.19vw] left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 transform overflow-hidden"
      >
        <img
          src="@/assets/images/AboutUs/module6/sample2.png"
          class="absolute w-auto h-auto object-cover left-[50%] -translate-x-1/2 top-[45%] -translate-y-1/2"
          alt="线条图"
        />
        <div class="shine"></div>
      </div>

      <!-- 文字区域1 -->
      <div
        class="absolute w-[12.3vw] inline-flex flex-col justify-center items-center gap-[0.83vw] top-[9.95vw] left-[1.6vw] group"
      >
        <div
          class="self-stretch justify-start text-[#676B73] text-[0.83vw] font-normal font-harmony leading-[1.55vw]"
          style="text-justify: inter-ideograph"
        >
          组建专业无人机教育团队，开启青少年科技培训领域探索。
        </div>
        <div
          class="px-4 py-[5px] bg-[#f28334] rounded-[17px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.15)] outline outline-2 outline-offset-[-1px] outline-white inline-flex justify-center items-center gap-2.5"
        >
          <div
            class="text-center justify-start text-white text-[0.94vw] font-bold font-harmony"
          >
            创业奠基
          </div>
        </div>
        <div
          class="text-center justify-start text-black text-[0.94vw] font-bold font-harmony"
        >
          2019
        </div>
        <div
          class="size-[1.26vw] mt-[0.7vw] bg-[#FFFFFF]/90 rounded-full border-2 border-[#f28334]/60 shadow-[0_4px_10px_rgba(0,0,0,0.3)] relative overflow-hidden"
        >
          <div
            class="absolute inset-0 bg-[#f28334]/90 origin-center scale-0 group-hover:scale-110 transition-transform duration-300 clip-path-circle"
          ></div>
        </div>
      </div>
      <!-- 文字区域2 -->
      <div
        class="absolute w-[13.7vw] inline-flex flex-col justify-center items-center gap-[0.83vw] bottom-[3.87vw] left-[10.4vw] group"
      >
        <div
          class="size-[1.26vw] mb-[2.3vw] bg-[#FFFFFF]/90 rounded-full border-2 border-[#f28334]/60 shadow-[0_4px_10px_rgba(0,0,0,0.3)] relative overflow-hidden"
        >
          <div
            class="absolute inset-0 bg-[#f28334]/90 origin-center scale-0 group-hover:scale-110 transition-transform duration-300 clip-path-circle"
          ></div>
        </div>
        <div
          class="text-center justify-start text-black text-[0.94vw] font-bold font-harmony"
        >
          2020
        </div>
        <div
          class="px-4 py-[5px] bg-[#f28334] rounded-[17px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.15)] outline outline-2 outline-offset-[-1px] outline-white inline-flex justify-center items-center gap-2.5"
        >
          <div
            class="text-center justify-start text-white text-[0.94vw] font-bold font-harmony"
          >
            初显锋芒
          </div>
        </div>
        <div
          class="self-stretch justify-start text-[#676B73] text-[0.83vw] font-normal font-harmony leading-[1.55vw]"
          style="text-justify: inter-ideograph"
        >
          首次组织学员参加全国青少年无人机大赛；启动“青少年无人机义务科普”公益项目，覆盖多所中小学。
        </div>
      </div>
      <!-- 文字区域3 -->
      <div
        class="absolute w-[12.6vw] inline-flex flex-col justify-center items-center gap-[0.83vw] top-[4.8vw] left-[21.35vw] group"
      >
        <div
          class="self-stretch justify-start text-[#676B73] text-[0.83vw] font-normal font-harmony leading-[1.55vw]"
          style="text-justify: inter-ideograph"
        >
          正式成立蓝悦教育科技有限公司，团队企业化运营；赛事培训体系成熟，辅导29人参赛全国大赛。
        </div>
        <div
          class="px-4 py-[5px] bg-[#f28334] rounded-[17px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.15)] outline outline-2 outline-offset-[-1px] outline-white inline-flex justify-center items-center gap-2.5"
        >
          <div
            class="text-center justify-start text-white text-[0.94vw] font-bold font-harmony"
          >
            战略升级
          </div>
        </div>
        <div
          class="text-center justify-start text-black text-[0.94vw] font-bold font-harmony"
        >
          2023
        </div>
        <div
          class="size-[1.26vw] mt-[0.7vw] bg-[#FFFFFF]/90 rounded-full border-2 border-[#f28334]/60 shadow-[0_4px_10px_rgba(0,0,0,0.3)] relative overflow-hidden"
        >
          <div
            class="absolute inset-0 bg-[#f28334]/90 origin-center scale-0 group-hover:scale-110 transition-transform duration-300 clip-path-circle"
          ></div>
        </div>
      </div>
      <!-- 文字区域4 -->
      <div
        class="absolute w-[15.7vw] inline-flex flex-col justify-center items-center gap-[0.83vw] bottom-[7.87vw] right-[14.2vw] group"
      >
        <div
          class="size-[1.26vw] mb-[2.25vw] bg-[#FFFFFF]/90 rounded-full border-2 border-[#f28334]/60 shadow-[0_4px_10px_rgba(0,0,0,0.3)] relative overflow-hidden"
        >
          <div
            class="absolute inset-0 bg-[#f28334]/90 origin-center scale-0 group-hover:scale-110 transition-transform duration-300 clip-path-circle"
          ></div>
        </div>
        <div
          class="text-center justify-start text-black text-[0.94vw] font-bold font-harmony"
        >
          2024
        </div>
        <div
          class="px-4 py-[5px] bg-[#f28334] rounded-[17px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.15)] outline outline-2 outline-offset-[-1px] outline-white inline-flex justify-center items-center gap-2.5"
        >
          <div
            class="text-center justify-start text-white text-[0.94vw] font-bold font-harmony"
          >
            体系完善
          </div>
        </div>
        <div
          class="self-stretch justify-start text-[#676B73] text-[0.83vw] font-normal font-harmony leading-[1.55vw]"
          style="text-justify: inter-ideograph"
        >
          启动课程标准化建设，完成小学段无人机教材与配套教具研发；全国无人机大赛参赛人数爆发式增长至243人，行业影响力显著提升。
        </div>
      </div>
      <!-- 文字区域5 -->
      <div
        class="absolute w-[17.3vw] inline-flex flex-col justify-center items-center gap-[0.83vw] top-0 right-[1.55vw] group"
      >
        <div
          class="self-stretch justify-start text-[#676B73] text-[0.83vw] font-normal font-harmony leading-[1.55vw]"
          style="text-justify: inter-ideograph"
        >
          无人机教育课程体系开发完成，形成覆盖小学—高中全链条的系统化解决方案；启动全国加盟计划，开放了课程体系、师资培训与赛事支持，实现品牌规模化复制。
        </div>
        <div
          class="px-4 py-[5px] bg-[#f28334] rounded-[17px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.15)] outline outline-2 outline-offset-[-1px] outline-white inline-flex justify-center items-center gap-2.5"
        >
          <div
            class="text-center justify-start text-white text-[0.94vw] font-bold font-harmony"
          >
            高速发展
          </div>
        </div>
        <div
          class="text-center justify-start text-black text-[0.94vw] font-bold font-harmony"
        >
          2025
        </div>
        <div
          class="size-[1.26vw] mt-[0.7vw] bg-[#FFFFFF]/90 rounded-full border-2 border-[#f28334]/60 shadow-[0_4px_10px_rgba(0,0,0,0.3)] relative overflow-hidden"
        >
          <div
            class="absolute inset-0 bg-[#f28334]/90 origin-center scale-0 group-hover:scale-110 transition-transform duration-300 clip-path-circle"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "abouotus-module5",
  data() {
    return {};
  },
};
</script>

<style scoped>
.shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 30%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shine 5s infinite linear;
}

@keyframes shine {
  0% {
    left: -30%;
  }
  100% {
    left: 100%;
  }
}

.clip-path-circle {
  clip-path: circle(50% at 50% 50%);
}
</style>